import { Box, Flex, Spacer, VStack } from '@chakra-ui/react';
import { AccountShipTos } from '@diamond/shared/types';
import { Button, Card, Text } from '@diamond/shared/ui';
import { useShipToStore } from '@diamond/sol-buyer-context';
import { setCookie } from 'cookies-next';
import shallow from 'zustand/shallow';

interface OptionShipToProps {
  shipTos?: AccountShipTos;
  onSubmit: () => void;
}

export function OptionShipTo({ shipTos, onSubmit }: OptionShipToProps) {
  const avaliableShipTos = shipTos ?? [];

  const [setSelectedShipToId, setSelectedShipToDc, setSelectedShipTo] =
    useShipToStore(
      (s) => [
        s.setSelectedShipToId,
        s.setSelectedShipToDc,
        s.setSelectedShipTo,
      ],
      shallow
    );

  const handleSelect = (
    value: AccountShipTos[number],
    id: string,
    distribution_channel: string
  ) => {
    setCookie('selected_shipto_id', id);
    setCookie('selected_shipto_dc', distribution_channel);
    setSelectedShipToId(id);
    setSelectedShipToDc(distribution_channel);
    setSelectedShipTo(value);
    onSubmit();
  };

  return (
    <Box mx={-2} mt={-6} mb={-4}>
      {avaliableShipTos?.map((value, index) => {
        return (
          <Card
            key={index}
            p={4}
            border="1px"
            borderColor="blue"
            rounded="lg"
            my="24px"
            cursor="pointer"
            role="group"
            _hover={{ bg: '#EDF2F7', color: 'blue', borderColor: 'blue' }}
          >
            <Box>
              <Flex alignItems="center">
                <VStack spacing={2} align="flex-start">
                  <Text fontWeight="semibold">{value.name}</Text>
                  <Text fontSize="sm">NAMA PIC: {value.pic_name ?? '-'}</Text>
                  <Text fontSize="sm">{value.address}</Text>
                </VStack>
                <Spacer />
                <Button
                  ml={6}
                  id="btn-select-shipto"
                  aria-label={`Pilih ${value.name}`}
                  _groupHover={{
                    bg: 'blue',
                    borderColor: 'white',
                    color: 'white',
                  }}
                  px={8}
                  onClick={() =>
                    handleSelect(value, value.id, value.distribution_channel)
                  }
                >
                  Pilih
                </Button>
              </Flex>
            </Box>
          </Card>
        );
      })}
    </Box>
  );
}
